import { useState } from "react";

// Custom hook to handle form logic
function useForm(callback) {
  // State to hold form values
  const [values, setValues] = useState({});

  // State to hold form errors
  const [errors, setErrors] = useState({});

  // Function to handle changes to form inputs
  const handleChange = (event) => {
    setValues({
      ...values, // Keep existing form values
      [event.target.name]: event.target.value, // Update the value of the specific input
    });
  };

  // Function to handle form submission
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    callback(); // Execute the callback function passed to the hook
  };

  // Return form state and handlers for use in components
  return {
    values, // Form values
    handleChange, // Function to handle input changes
    handleSubmit, // Function to handle form submission
    errors, // Form errors
    setErrors, // Function to manually set errors
    setValues, // Function to manually set values
  };
}

export default useForm;
